<template>
  <div id="app" ref="myBody">
    <router-view />
    <!-- <canvas ref="myCanvas"></canvas> -->
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      img: "",
      /** 当前所属环境 com-wx-mobile手机端企业微 com-wx-pc电脑端企微 other其他环境（外部浏览器）*/
      environment: "",
    };
  },
  methods: {
    /** 获取当前环境 */
    getEnvironment() {
      let isMobile = window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      ); // 是否手机端
      let isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信
      if (isComWx && isMobile) {
        //手机端企业微信
        this.environment = "com-wx-mobile";
      } else if (isComWx && !isMobile) {
        //PC端企业微信
        this.environment = "com-wx-pc";
      } else {
        //其他环境
        this.environment = "other";
      }
      window.localStorage.setItem("environment", this.environment);
    },
    // 画水印
    // drawWaterPrint() {
    //   this.$nextTick(() => {
    //     let mybody,canvas
    //     if(!this.img) {
    //       mybody = this.$refs.myBody
    //       canvas = this.$refs.myCanvas
    //       canvas.style = 'display:none'
    //       canvas.width = 200
    //       canvas.height = 200
    //       const ctx = canvas.getContext('2d')
    //       ctx.font = '16px sans-serif'
    //       ctx.fillStyle = 'rgba(0,0,0,.3)'
    //       ctx.rotate(-0.3)
    //       ctx.fillText('宏脉软件',canvas.width/8,canvas.height/4)
    //       this.img = canvas.toDataURL('image/png')
    //     }
    //     const style = `background-image:url(${this.img})`
    //     mybody.setAttribute('style',style)
    //     console.log('1111111')
    //   })
    // },
    // myCallBack() {
    //   // console.log('ssssssssssss')
    //   this.$nextTick(() => {
    //     console.log(this.$refs.myBody.style.backgroundImage,22222)
    //     console.log(`url(${this.img})`,222223333)
    //     console.log(this.$refs.myBody.style.backgroundImage !== `url(${this.img})`,111)
    //     if(this.$refs.myBody.style.backgroundImage !== this.img) {
    //       // this.drawWaterPrint()
    //     }
    //   })
    // }
  },
  async created() {
    await this.getEnvironment();
    // this.drawWaterPrint()
    // this.$nextTick(() => {
    //   const observer = new MutationObserver(this.myCallBack)
    //   const treeNode = this.$refs.myBody
    //   const config = {attributes: true}
    //   observer.observe(treeNode,config)
    // })
  },
};
</script>
<style lang="scss">
/*全局公共样式，每个页面公共css*/
@import "@/style/common.scss"; //@代表的是项目根路径
html,
body {
  width: 100%;
  height: 100%;
  // box-sizing: border-box;
  // padding: 0px;
  margin: 0px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  widows: 100%;
  height: 100%;
}
.el-popover {
  z-index: 200 !important;
}
.el-popover-index {
  z-index: 3000 !important;
}
</style>
